import L from "leaflet";

export const OPEN_STREET_MAP_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
export const OPEN_STREET_MAP_ATTRIBUTION = "&copy; OpenStreetMap contributors";

const LEAFLET_ASSET_BASE = "https://unpkg.com/leaflet@1.9.4/dist/images";

let defaultsApplied = false;

/**
 * Applies the shared Leaflet default marker icon once. Importing this module
 * (via `MapSurface`) is enough; calling is only needed for explicit ordering.
 */
export const ensureLeafletDefaults = (): void => {
  if (defaultsApplied) return;
  defaultsApplied = true;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: `${LEAFLET_ASSET_BASE}/marker-icon-2x.png`,
    iconUrl: `${LEAFLET_ASSET_BASE}/marker-icon.png`,
    shadowUrl: `${LEAFLET_ASSET_BASE}/marker-shadow.png`,
  });
};
